// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bookmarker-panel[data-v-3f2121f3]{height:100%}.container[data-v-3f2121f3]{height:calc(100% - 91px);border-radius:0;overflow-y:auto}.container[data-v-3f2121f3],.list-item[data-v-3f2121f3]{border-bottom:1px solid #c3c0c0}.list-item[data-v-3f2121f3]{display:flex;padding-bottom:10px;padding-top:10px;justify-content:space-between;align-items:center}.bookmark-label[data-v-3f2121f3]{cursor:pointer;text-decoration:underline}.bookmark-label[data-v-3f2121f3]:hover{text-decoration:none}", ""]);
// Exports
module.exports = exports;
